import logger from '../../logger';
import generatedHooks from '../../hooks/generatedHooks';
import wrapInObserver from '../wrapInObserver';
import RatingTabs from './RatingTabs';

const {
  useUiStore,
  useRootStore,
} = generatedHooks;

const mapProps = () => {
  try {
    const { reload } = useRootStore(store => store);

    const {
      switchGroup,
      groupId,
      tabs,
    } = useUiStore(store => store);

    const handleTabChange = (newGroupId) => {
      if (newGroupId !== groupId) {
        switchGroup(newGroupId);
        reload();
      }
    };

    return {
      groupId,
      handleTabChange,
      tabs,
    };
  } catch (error) {
    logger.error(error);
    return {};
  }
};

export default wrapInObserver(RatingTabs, mapProps);
